var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 2,
    fill: "#39444F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3747_91965)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.89575 16.4461H14.4635V8.07208H9.89575V16.4461Z",
    fill: "#E2E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.186 12.2591C10.186 10.5602 10.9658 9.04712 12.1799 8.07208C11.2919 7.35889 10.1715 6.93343 8.95376 6.93343C6.07084 6.93343 3.73389 9.31784 3.73389 12.2591C3.73389 15.2003 6.07084 17.5847 8.95376 17.5847C10.1715 17.5847 11.2919 17.1593 12.1799 16.4461C10.9658 15.4709 10.186 13.958 10.186 12.2591Z",
    fill: "#B2B6BA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4627 15.5592V15.3525H20.4098L20.349 15.4947L20.2881 15.3525H20.2352V15.5592H20.2725V15.4032L20.3296 15.5377H20.3683L20.4255 15.4029V15.5592H20.4627ZM20.1276 15.5592V15.3877H20.1955V15.3528H20.0229V15.3877H20.0906V15.5592H20.1276ZM20.6257 12.259C20.6257 15.2003 18.2886 17.5847 15.4058 17.5847C14.1881 17.5847 13.0676 17.1592 12.1797 16.446C13.3938 15.471 14.1736 13.9579 14.1736 12.259C14.1736 10.5603 13.3938 9.04722 12.1797 8.07203C13.0676 7.35884 14.1881 6.93338 15.4058 6.93338C18.2886 6.93338 20.6257 9.31779 20.6257 12.259Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3747_91965"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.0667,
    height: 10.6667,
    fill: "white",
    transform: "translate(3.73364 6.93343)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.b28639b0.svg";
export { ForwardRef as ReactComponent };